/**
 * Abas horizontais da coluna de info da PDP (Figma 104:2682).
 * O markup ja vem completo do Liquid — este componente so troca qual painel
 * fica visivel, entao sem JS o primeiro painel continua legivel.
 */
if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        const offset = { ArrowRight: 1, ArrowLeft: -1, Home: -index, End: this.tabs.length - 1 - index }[event.key];
        if (offset === undefined) return;
        event.preventDefault();
        const next = (index + offset + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });
      }
    }
  );
}
